/**
 * Created by Mark on 17/03/2017.
 */

import React from "react";
import { FormattedMessage } from 'react-intl';

class SingleInput extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggled: this.props.content.length > 0 ? true : this.props.toggled,
            validation:this.props.validationType || false,
            validationText:this.props.validationText || false
        }

    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({ validationText:nextProps.validationText || false , validation:nextProps.validationType || false });
    }

    toggleFocus() {
        if (!(!this.input.value || 0 === this.input.value.length)) this.setState({ toggled: true });
        else this.setState({ toggled: !this.state.toggled });
    }

    renderLabel(){
        if(this.props.disableLabel) return;
        else return <label className="fg-label"><FormattedMessage id={this.props.labelTranslationUID || 'ui'} defaultMessage={this.props.labelName}/></label>;
    }

    renderHelpText(){
        if(!this.state.validation) return;
        else return <small className="help-block animate fadeIn">{this.state.validationText}</small>
    }

    getValidationClass(){
        switch (this.state.validation){
            case "warning" : return "has-warning";
            case "error": return "has-error";
        }
    }

    render() {
        return (
            <div className={this.getValidationClass() + " form-group fg-float"}>
                <div className={'fg-line ' + (this.state.toggled ? 'fg-toggled' : '')} >
                    <input
                        ref={(input) => this.input = input}
                        className="form-input"
                        name={this.name}
                        type={this.inputType}
                        value={this.props.content}
                        onChange={this.props.controlFunc}
                        onBlur={this.toggleFocus.bind(this)}
                        onFocus={this.toggleFocus.bind(this)}
                        className="input-sm form-control fg-input" />
                        {this.renderLabel()}
                </div>
                {this.renderHelpText()}
            </div>
        );
    }
}

SingleInput.propTypes = {
    inputType: React.PropTypes.oneOf(['text', 'number']).isRequired,
    validationType: React.PropTypes.oneOf(['warning', 'error' , 'success']),
    title: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    controlFunc: React.PropTypes.func.isRequired,
    content: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number,
    ]).isRequired,
    placeholder: React.PropTypes.string,
};

export default SingleInput;


// WEBPACK FOOTER //
// ./src/components/inputs/single.input.js